import React, { useState } from 'react';
import Text from '../single_component/Text';
import Box from '../single_component/Box';
import Circle from '@mui/icons-material/Circle';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Priority from '../common_component/Priority';
import DeleteConfirmModal from '../common_component/DeleteConfirmModal';
import Props from '../../types/props';
import StringUtils from '../../utils/stringUtil';
import moment from 'moment';
import { toast } from 'react-toastify';

function SalesToDolist({ ...props }: Props) {
  const { value, deleteTodo } = props.extra;
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const handleDeleteConfirm = async () => {
    setDeleteLoading(true);
    const response = await deleteTodo(value.todoId);
    setDeleteLoading(false);
    setDeleteModalOpen(false);
    if (response.success) {
      toast.success(response.message);
    } else {
      toast.error(response.message);
    }
  };

  return (
    <Box
      {...props}
      style={{
        gap: 2,
        borderBottom: '1px solid #EDEDED ',
        padding: '12px 14px',
      }}>
      <Box style={{ display: 'flex', flexDirection: 'column' }}>
        <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box style={{ display: 'flex', gap: 2 }}>
            <Box
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 1,
              }}>
              <Circle sx={{ fontSize: 8 }} color="primary" />
              <Text style={{ fontSize: 14, fontWeight: 'bolder' }}>
                {StringUtils.capitalizeFirstLetter(value.subject)}
              </Text>
            </Box>
            <Text style={{ color: '#757575', fontWeight: 500, fontSize: 13 }}>
              {moment(value.startDate, 'YYYY-MM-DD').format('MMM DD, YYYY')} -{' '}
              {moment(value.endDate, 'YYYY-MM-DD').format('MMM DD, YYYY')}
            </Text>
          </Box>
          <Box style={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Priority label={value.priority} />
            <DeleteOutlineIcon
              sx={{ cursor: 'pointer', color: '#d32f2f', fontSize: 18 }}
              onClick={() => setDeleteModalOpen(true)}
            />
          </Box>
        </Box>

        <Box style={{ marginTop: 0.7 }}>
          <Text style={{ fontSize: 13, color: '#104960' }}>
            {StringUtils.capitalizeFirstLetter(value.note)}
          </Text>
        </Box>
      </Box>
      <DeleteConfirmModal
        open={deleteModalOpen}
        onCancel={() => setDeleteModalOpen(false)}
        onConfirm={handleDeleteConfirm}
        loading={deleteLoading}
      />
    </Box>
  );
}

export default SalesToDolist;
